export const WIZARD_SET_INFO = 'WIZARD_SET_INFO'
export const WIZARD_UPDATE_NEW_PRICE = 'WIZARD_UPDATE_NEW_PRICE'
export const WIZARD_SET_DEFAULT_NEW_PRICE = 'WIZARD_SET_DEFAULT_NEW_PRICE'
export const WIZARD_CLEAR_INFO = 'WIZARD_CLEAR_INFO'
